import React, {useEffect, useMemo, useState} from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvCheckbox, AvCheckboxGroup, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

const BabySymptomsStep: React.FC<StepComponentProps> = ({
                                                          formData,
                                                          updateFormData,
                                                          onNext,
                                                          onPrevious,
                                                          canGoBack,
                                                          canGoNext,
                                                          patientCaseType,
                                                          journey,
                                                          babySymptomsData,
                                                        }) => {
  const [selectedSymptoms, setSelectedSymptoms] = useState<string[]>(formData.babySymptoms || []);
  const [babySymptomDetails, setBabySymptomDetails] = useState(formData.babySymptom || '');
  const [isOtherSelected, setIsOtherSelected] = useState(false);

  const patientCountryId = journey.patientCase?.patient?.countryId;

  // Get symptoms for baby from real data
  const babySymptoms = useMemo(() => {
    return babySymptomsData || [];
  }, [babySymptomsData]);

  useEffect(() => {
    updateFormData({
      babySymptoms: selectedSymptoms,
      babySymptom: babySymptomDetails
    });
  }, [selectedSymptoms, babySymptomDetails]);

  useEffect(() => {
    // Update isOtherSelected when symptoms or selectedSymptoms change
    if (babySymptoms.length > 0 && selectedSymptoms.length > 0) {
      const sortedSymptoms = [...babySymptoms].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
      const lastSymptom = sortedSymptoms[sortedSymptoms.length - 1];
      setIsOtherSelected(selectedSymptoms.includes(lastSymptom?.id));
    } else {
      setIsOtherSelected(false);
    }
  }, [babySymptoms, selectedSymptoms]);

  const handleSymptomChange = event => {
    // Sort symptoms by displayOrder and check if the last symptom (highest displayOrder) is selected
    const sortedSymptoms = [...babySymptoms].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
    const lastSymptom = sortedSymptoms[sortedSymptoms.length - 1];
    setIsOtherSelected(selectedSymptoms.includes(lastSymptom?.id));
  };

  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  const handleBabySymptomDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBabySymptomDetails(e.target.value);
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="mb-4">Please select any additional baby symptoms.</h6>
        <AvForm onValidSubmit={handleSubmit}>
          <Row>
            <Col md="12">
              <AvGroup>
                <AvCheckboxGroup
                  name="babySymptoms"
                  className="form-control"
                  style={{overflowY: 'auto', height: '400px'}}
                  value={selectedSymptoms}
                >
                  {babySymptoms.length === 0 ? (
                    <p>No symptoms available for this emergency type.</p>
                  ) : (
                    [...babySymptoms]
                      .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
                      .map(symptom => (
                        <AvCheckbox
                          key={symptom.id}
                          value={symptom.id}
                          label={symptom.enCondition}
                          onChange={handleSymptomChange}
                        />
                      ))
                  )}
                </AvCheckboxGroup>
              </AvGroup>
            </Col>
          </Row>
          {isOtherSelected && (
            <Row>
              <Col md="12">
                <AvGroup>
                  <Label for="babySymptomDetails">Baby Symptom Details</Label>
                  <AvInput
                    type="text"
                    name="babySymptomDetails"
                    id="babySymptomDetails"
                    value={babySymptomDetails}
                    onChange={handleBabySymptomDetailsChange}
                    maxLength={255}
                    placeholder="Please specify the symptom details"
                    required
                  />
                </AvGroup>
              </Col>
            </Row>
          )}
          <FollowupButtons
            currentStep={3}
            totalSteps={10}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default BabySymptomsStep;
